<template>
  <a href="#" class="notification"><img class="notification__icon" :src="'/images/module-icons/'+formatToPath(notificationModule)+'.svg'">{{ notificationText }}</a>
</template>

<script>
export default {
  name: 'NotificationRow',
  props: {
    notificationModule: String,
    notificationText: String
  },
  data() {
    return {

    }
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {

  }
}
</script>
